import { mapSuccessResponse } from './utils';
import { IJoinFairPlayParams, TJoinFairPlayResult } from './types';
import {
  fetchCreateActionCheck,
  TCreateActionCheckResponse,
} from '../../../repositories/moderation-action-check/v1/create-action-check';
import { EFairPlayErrorCode } from '../../../redux/reducers/fairPlay';

export async function joinFairPlay(params: IJoinFairPlayParams): Promise<TJoinFairPlayResult> {
  const { httpApi, logger } = params;

  try {
    const response: TCreateActionCheckResponse = await fetchCreateActionCheck({ httpApi, parameters: {} });

    if (response.statusCode === 200) {
      return mapSuccessResponse(response.response);
    }
  } catch (error) {
    logger.error(error, {
      description: 'Запрос /create-action-check/ на ФП',
      degradation: 'Пользователь не смог подать заявку на программу "Работаем честно"',
    });
  }

  return {
    success: false,
    payload: {
      errorCode: EFairPlayErrorCode.fatalError,
      error: null,
    },
  };
}
